module.exports = __webpack_public_path__ + "img/lifting-station-lg.72491e63.svg";